import { render, staticRenderFns } from "./lessPoweTrend.vue?vue&type=template&id=3facc12a&scoped=true&"
import script from "./lessPoweTrend.vue?vue&type=script&lang=js&"
export * from "./lessPoweTrend.vue?vue&type=script&lang=js&"
import style0 from "./lessPoweTrend.vue?vue&type=style&index=0&id=3facc12a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3facc12a",
  null
  
)

export default component.exports